export enum BuildView {
  Index = "INDEX",
  Steps = "STEPS",
  Summary = "SUMMARY",
  JobList = "JOB_LIST",
  Waterfall = "WATERFALL",
  Table = "TABLE",
  Canvas = "CANVAS",
  Tests = "TESTS",
  Annotations = "ANNOTATIONS",
}
